// temporary feature switches:
export const USE_FRODOR_FOOTER = false;
export const USE_SEARCH = false;
